import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { AuthSplitLayout } from 'src/layouts/auth-split';

import { SplashScreen } from 'src/components/loading-screen';

import { GuestGuard } from 'src/auth/guard';
import PublicRoute from 'src/auth/guard/public-route';

// ----------------------------------------------------------------------

/** **************************************
 * Jwt
 *************************************** */
const Jwt = {
  SignInPage: lazy(() => import('src/pages/auth/jwt/sign-in')),
};

const authJwt = {
  path: '/',
  element:(
    <Outlet/>
  ),
  children: [
    {
      path: 'login',
      element: (
       
          <AuthSplitLayout>
            <Jwt.SignInPage />
          </AuthSplitLayout>
       
      ),
    },
  ],
};

// ----------------------------------------------------------------------

export const authRoutes: RouteObject[] = [
  {
    path: '/',
    element: (
      <PublicRoute>
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
      </PublicRoute>
    ),
    children: [authJwt],
  },
  
];
